import React from "react";

export function EmptyState({ icon: Icon, title, description, action, testId }) {
    return (
        <div
            data-testid={testId || "empty-state"}
            className="flex flex-col items-center justify-center text-center py-20 px-6 rounded-3xl border border-dashed border-sand-300 bg-white"
        >
            {Icon && (
                <div className="h-14 w-14 rounded-2xl bg-ocean-50 text-secondary flex items-center justify-center mb-5">
                    <Icon className="h-6 w-6" />
                </div>
            )}
            <h3 className="font-heading text-xl text-ocean-700">{title}</h3>
            {description && <p className="mt-2 text-sm text-muted-foreground max-w-md">{description}</p>}
            {action && <div className="mt-6">{action}</div>}
        </div>
    );
}

export default EmptyState;
